<template>
  <div class="container google-login-wrapper">
    <el-button
      :icon="isWorking ? 'icon-loading' : ''"
      class="google-button"
      round
      @click="buttonClicked"
    >
      <i
        v-if="!isWorking"
        class="icon-google"
      ><i class="path1" /><i class="path2" /><i class="path3" /><i
        class="path4"
      /></i>
      <span
        class="text"
        v-html="getButtonText"
      />
    </el-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Vue from 'vue';
Vue.prototype.lazyLoadPackages.googleOauth.load();

export default {
  props: {
    version: {
      type: String,
      default: 'v2.10',
    },
    logoutLabel: {
      type: String,
      default: 'Log out from Google',
    },
    loginLabel: {
      type: String,
      default: 'Log In To Google',
    },
    loginOptions: {
      type: Object,
      default() {
        return {
          scope: 'email',
        };
      },
    },
  },
  data() {
    return {
      isWorking: false,
      isConnected: false,
      icon: false,
    };
  },
  computed: {
    getButtonText() {
      let result = '';
      switch (this.isConnected) {
        case true:
          result = this.logoutLabel;
          break;
        case false:
          result = this.loginLabel;
          break;
        default:
          result = 'this is default';
      }
      return result.replace('/', '<b>').replace('\\', '</b>');
    },
    ...mapState({
      googleInit: state => state.temp.social.googleInit,
    }),
  },
  methods: {
    buttonClicked() {
      this.$emit('click');
      this.login();
    },
    login() {
      this.isWorking = true;
      Vue.GoogleAuth.then((auth2) => {
        if (auth2.isSignedIn.get()) {
          // we can get token
          const authorizationCode = auth2.currentUser.get().getAuthResponse().id_token;
          this.$emit('login', {
            authorizationCode,
          });
        } else {
          auth2.signIn()
            .then((currentUser) => {
              const authorizationCode = currentUser.getAuthResponse().id_token;
              this.$emit('login', {
                authorizationCode,
              });
              this.isWorking = false;
            }, () => {
              this.isWorking = false;
            });
        }
        this.isWorking = false;
      });
    },
  },
};
</script>



<style scoped>
  .google-login-wrapper button {
    position: relative;
    padding: 0 15px 0px 46px;
    border: none;
    line-height: 34px;
    font-size: 16px;
    color: #FFF;
    min-width: 225px;
    background-image: linear-gradient(#4688f6, #3e7df6);
  }

  .google-login-wrapper .spinner {
    box-sizing: border-box;
    width: 30px;
    height: 90%;
    border-radius: 50%;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    animation: spin 2s linear infinite;
    position: absolute;
    left: 5px;
  }

  .google-login-wrapper img {
    position: absolute;
    top: 3px;
    left: 10px;
    width: 30px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/conectivity/GoogleLogin.vue